import { helpAnswerLanguage } from "./helpAnswerLanguage";

/**
 * The language a help-chat message is written in, told apart by its function words — the short
 * words every sentence needs and the two languages do not share. Umlauts and ß count for German.
 * `null` when the message does not say enough ("hi", "ok", a product name): two hits at least, and
 * one language ahead.
 */
const GERMAN_WORDS = new Set(
	"und ich wie ist nicht das die der den dem ein eine einen mit auf für zu kann können meine mein wo was warum bitte wird sind sie du es im von oder auch noch habe hast gibt geht wieso weshalb welche welcher wann hallo danke mir mich dich ihr uns kein keine schon aber wenn dann".split(
		" "
	)
);
const ENGLISH_WORDS = new Set(
	"the how do does i is my what why can you to a an and of in for with please are where this it not can't don't my me your have has there which when hello thanks we our no but if then should would could get".split(
		" "
	)
);
const MIN_HITS = 2;

export const detectMessageLanguage = (message: string): "en" | "de" | null => {
	const text = message.toLowerCase();
	const words = text.match(/[a-zäöüß']+/g) ?? [];
	let de = /[äöüß]/.test(text) ? 2 : 0;
	let en = 0;

	for (const word of words) {
		de += GERMAN_WORDS.has(word) ? 1 : 0;
		en += ENGLISH_WORDS.has(word) ? 1 : 0;
	}

	if (Math.max(de, en) < MIN_HITS || de === en) {
		return null;
	}

	return de > en ? "de" : "en";
};

/**
 * The language the assistant answers this turn in: the language the user is writing in; when the
 * message is too short to tell, the previous turn's; on a first turn, the browser's. The
 * assistant does not infer a language itself (contract §4.8), and choosing the browser's for every
 * turn answered English questions in German for every DACH user (PREC-4067).
 */
export const chooseAnswerLanguage = (
	message: string,
	previous: string | null,
	browserLanguage?: string | null
): string => detectMessageLanguage(message) ?? previous ?? helpAnswerLanguage(browserLanguage);
